export class GitDiffEntry {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "path",
            "baseName": "path",
            "type": "string",
            "format": ""
        },
        {
            "name": "changeType",
            "baseName": "changeType",
            "type": "DiffChangeType",
            "format": ""
        },
        {
            "name": "additions",
            "baseName": "additions",
            "type": "number",
            "format": ""
        },
        {
            "name": "deletions",
            "baseName": "deletions",
            "type": "number",
            "format": ""
        },
        {
            "name": "oldPath",
            "baseName": "oldPath",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GitDiffEntry.attributeTypeMap;
    }
    constructor() {
    }
}
